





































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import RestStatus from '@/client/components/core/RestStatus.vue';
import Alert from '@/client/components/core/Alert.vue';
import api from '../../util/api';

@Component({
  components: {
    Alert,
    RestStatus,
  },
})
export default class Contact extends Vue {
  name = '';
  email = '';
  message = '';
  boolean = false;
  loading = false;
  error = false;
  responseType = '';
  alertMessage = '';
  showAlert = false;

  resetForm() {
    this.message = '';
    this.name = '';
    this.email = '';
    this.boolean = false;
  }

  resetAlert() {
    this.alertMessage = '';
    this.responseType = '';
    this.showAlert = false;
  }

  popAlert(response: any) {
    this.responseType = response.status === 200 ? 'success' : 'danger';
    this.alertMessage = response.message;
    this.showAlert = true;
  }

  submitLead() {
    this.resetAlert();
    this.loading = true;

    const lead = {
      name: this.name,
      email: this.email,
      message: this.message,
    };

    api('POST', 'http://localhost:3000/api/leads/question', lead)
      .then((response: any) => {
        this.loading = false;
        this.resetForm();
        this.popAlert(response);
      });
  }

  // eslint-disable-next-line class-methods-use-this
  sectionBackground(image: string) {
    return {
      backgroundImage: `url(${image})`,
    };
  }
}
